/* eslint-disable @typescript-eslint/no-explicit-any */
import { useGetApi } from "@src/api/useApi";
import { EAdmissionStages } from "@src/constants/modals/admissions";
import { AdmissionStagesAPI } from "@src/constants/static/AdmissionStages";

export type AdmissionAPIParams  = {
section:EAdmissionStages
userId?:string
applicationNumber?: string
}
export const useAdmissionStageApiHook = ({
      key,
      params,
      enabled = true,
}: {
      key: EAdmissionStages;
      params?: AdmissionAPIParams;
      id?: string;
      enabled?: boolean;
}) => {
      const admissionStagesConfig = AdmissionStagesAPI;
      return useGetApi({
            key: `admission-stage-${key}`,
            url: admissionStagesConfig[key]?.getUrl,
            params,
            enabled
      });
};
